const _temp0 = require("../../intl/toast/ar-AE.json");
const _temp1 = require("../../intl/toast/bg-BG.json");
const _temp2 = require("../../intl/toast/cs-CZ.json");
const _temp3 = require("../../intl/toast/da-DK.json");
const _temp4 = require("../../intl/toast/de-DE.json");
const _temp5 = require("../../intl/toast/el-GR.json");
const _temp6 = require("../../intl/toast/en-US.json");
const _temp7 = require("../../intl/toast/es-ES.json");
const _temp8 = require("../../intl/toast/et-EE.json");
const _temp9 = require("../../intl/toast/fi-FI.json");
const _temp10 = require("../../intl/toast/fr-FR.json");
const _temp11 = require("../../intl/toast/he-IL.json");
const _temp12 = require("../../intl/toast/hr-HR.json");
const _temp13 = require("../../intl/toast/hu-HU.json");
const _temp14 = require("../../intl/toast/it-IT.json");
const _temp15 = require("../../intl/toast/ja-JP.json");
const _temp16 = require("../../intl/toast/ko-KR.json");
const _temp17 = require("../../intl/toast/lt-LT.json");
const _temp18 = require("../../intl/toast/lv-LV.json");
const _temp19 = require("../../intl/toast/nb-NO.json");
const _temp20 = require("../../intl/toast/nl-NL.json");
const _temp21 = require("../../intl/toast/pl-PL.json");
const _temp22 = require("../../intl/toast/pt-BR.json");
const _temp23 = require("../../intl/toast/pt-PT.json");
const _temp24 = require("../../intl/toast/ro-RO.json");
const _temp25 = require("../../intl/toast/ru-RU.json");
const _temp26 = require("../../intl/toast/sk-SK.json");
const _temp27 = require("../../intl/toast/sl-SI.json");
const _temp28 = require("../../intl/toast/sr-SP.json");
const _temp29 = require("../../intl/toast/sv-SE.json");
const _temp30 = require("../../intl/toast/tr-TR.json");
const _temp31 = require("../../intl/toast/uk-UA.json");
const _temp32 = require("../../intl/toast/zh-CN.json");
const _temp33 = require("../../intl/toast/zh-TW.json");
module.exports = {
  "ar-AE": _temp0,
  "bg-BG": _temp1,
  "cs-CZ": _temp2,
  "da-DK": _temp3,
  "de-DE": _temp4,
  "el-GR": _temp5,
  "en-US": _temp6,
  "es-ES": _temp7,
  "et-EE": _temp8,
  "fi-FI": _temp9,
  "fr-FR": _temp10,
  "he-IL": _temp11,
  "hr-HR": _temp12,
  "hu-HU": _temp13,
  "it-IT": _temp14,
  "ja-JP": _temp15,
  "ko-KR": _temp16,
  "lt-LT": _temp17,
  "lv-LV": _temp18,
  "nb-NO": _temp19,
  "nl-NL": _temp20,
  "pl-PL": _temp21,
  "pt-BR": _temp22,
  "pt-PT": _temp23,
  "ro-RO": _temp24,
  "ru-RU": _temp25,
  "sk-SK": _temp26,
  "sl-SI": _temp27,
  "sr-SP": _temp28,
  "sv-SE": _temp29,
  "tr-TR": _temp30,
  "uk-UA": _temp31,
  "zh-CN": _temp32,
  "zh-TW": _temp33
}